<template>
	<div class="page-work page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">假日设置</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>系统设置</el-breadcrumb-item>
							<el-breadcrumb-item>假日设置</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleWork('add')">添加 <i
							class="el-icon-plus"></i></el-button>
					<el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="desk_name" width="180" label="所属店铺" align="center"></el-table-column>
							<el-table-column prop="type_name" align="center" label="假日类型" min-width="120">
								<template slot-scope="scope">
									<span :class="'tag-span tag-'+scope.row.type">{{scope.row.type_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="name" align="center" label="假日时间" min-width="240">
								<template slot-scope="scope">
									<span v-if="scope.row.type==1">{{scope.row.week_name}}</span>
									<span v-else-if="scope.row.type==2">{{scope.row.start_date}} -
										{{scope.row.end_date}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="status_name" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="handleWork('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini"
										@click="deleteWork(scope.row.id)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export work-dialog" :title="dlg_work.title" :visible.sync="dlg_work.visible"
			width="534px" @closed="closeWork" :close-on-click-modal="false">
			<el-form ref="formWork" :model="dlg_work.form" label-width="110px" :rules="dlg_work.rules"
				@submit.native.prevent>
				<el-form-item prop="week" label="所属店铺：">
					<el-select size="small" v-model="dlg_work.form.desk_number" placeholder="请选择">
						<el-option v-for="item in dlg_work.init_data.desk_name_list" :key="item.number"
							:label="item.name" :value="item.number">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type" label="假日类型：">
					<el-radio-group v-model="dlg_work.form.type">
						<el-radio v-for="(item, index) in dlg_work.init_data.type_list" :key="index" :label="item.id">
							{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="dlg_work.form.type==1" prop="week" label="设置假日时间：">
					<el-select size="small" v-model="dlg_work.form.week" placeholder="请选择">
						<el-option v-for="item in dlg_work.init_data.week_list" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-else-if="dlg_work.form.type==2" label="设置假日日期：">
					<el-date-picker size="small" clearable v-model="create_range" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item prop="status" label="状态：">
					<el-radio-group v-model="dlg_work.form.status">
						<el-radio v-for="(item, index) in dlg_work.init_data.status_list" :key="index" :label="item.id">
							{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_work.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitWork()" :loading="dlg_work.btn_loading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				multipleSelection: [],
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 30,
						total: 130
					}
				},
				create_range: '',
				dlg_work: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					form: {
						desk_number: '',
						type: 1,
						week: 0,
						start_date: '',
						end_date: '',
						status: 1
					},
					error: {
						desk_number: '',
						type: '',
						week: '',
						start_date: '',
						end_date: '',
						status: ''
					},
					reset_form: {},
					init_data: {
						desk_name_list: [],
						status_list: [],
						type_list: [],
						week_list: []
					},
					rules: {
						type: {
							required: true,
							message: '请选择假日类型',
							trigger: ['change', 'blur']
						},
						status: {
							required: true,
							message: '请选择状态',
							trigger: ['change', 'blur']
						}
					}
				}
			}
		},
		created() {
			document.title = '假日设置';
			this.dlg_work.reset_form = Object.assign({}, this.dlg_work.form);
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = {};
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				this.$client.get('/adminapi/workschedul/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.dlg_work.init_data.desk_name_list = res.desk_name_list;
					_this.dlg_work.init_data.status_list = res.status_name_list;
					_this.dlg_work.init_data.type_list = res.type_name_list;
					_this.dlg_work.init_data.week_list = res.week_name_list;
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delmultiple() {
				var _this = this;
				var mullist = this.multipleSelection;
				if (mullist.length == 0) {
					_this.$message("请勾选需要删除的假日");
					return;
				}
				var idList = [];
				for (var i = 0; i < mullist.length; i++) {
					idList.push(mullist[i].id);
				}
				var params = {
					id: idList.join(",")
				}
				this.$confirm('确定要批量删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/workschedul/delete', params, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},

			handleWork(type, data) {
				this.dlg_work.visible = true;
				if (type == 'add') {
					this.dlg_work.title = '添加节假日';
					this.dlg_work.api = '/adminapi/workschedul/save';
				} else {
					this.dlg_work.id = data.id;
					this.dlg_work.title = '编辑节假日';
					if (data) {
						for (var key in this.dlg_work.form) {
							this.dlg_work.form[key] = data[key];
						}
						if (data.week == -1) {
							this.dlg_work.form.week = 0;
						}
						this.create_range = [data.start_date, data.end_date]
					}
					this.dlg_work.api = '/adminapi/workschedul/save?id=' + data.id;
				}
			},
			deleteWork(id) {
				var _this = this;
				this.$confirm('确定要删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/workschedul/delete', {
							id: id
						}, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},
			submitWork() {
				var _this = this;
				_this.$refs['formWork'].validate((valid) => {
					console.log(this.dlg_work.form);
					if (valid) {
						if (this.dlg_work.form.type == 1) {
							if (this.dlg_work.form.week === '' || this.dlg_work.form.week === undefined) {
								_this.$message('请选择假日时间');
								return;
							}
						} else {
							if (this.dlg_work.form.start_date == '' || this.dlg_work.form.end_date == '') {
								_this.$message('请选择假日日期');
								return;
							}
						}
						this.dlg_work.btn_loading = true;
						this.$client.post(this.dlg_work.api, this.dlg_work.form, function(res, message) {
							//console.log(res)
							_this.$message(message);
							_this.getList();
							_this.dlg_work.btn_loading = false;
							_this.dlg_work.visible = false;
						}, function(message) {
							_this.dlg_work.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_work.error[key] = message[key];
								}
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeWork() {
				for (var key in this.dlg_work.form) {
					this.dlg_work.form[key] = this.dlg_work.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formWork.clearValidate();
				})
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.dlg_work.form.start_date = '';
					this.dlg_work.form.end_date = '';
				} else {
					this.dlg_work.form.start_date = newVal[0];
					this.dlg_work.form.end_date = newVal[1];
				}
			}
		}
	}
</script>
<style>

</style>
<style scoped>

</style>
